<section class="alarms">
  <ng-container>
    <div [ngClass]="{'global-actions-and-filters': callLogs?.list.length > 0 && allowGlobalActions}">
      <div class="">
        <app-filters-table
          [config]="filtersConfig"
          [filterType]="matchingType"
          [newItemFilter]="newItemFilter"
          [filtersList]="$safeNavigationMigration(dataForChildComponent?.body?.filters)"
          (eventEmitter)="eventReceiver($event)">
        </app-filters-table>
      </div>
    </div>
    @if (loadingState | async; as state) {
      <div>
        @if (state === actionState.LOADING) {
          <span class="ui-loading" [model]="{isLoading: true}"></span>
        }
        @if (state === actionState.READY) {
          <div>
            <div class="table-container">
              <div class="ui-table" (eventOnMouseenterRow)="onMouseenterRowEventOfTable($event)"
                (eventOnMouseleaveRow)="onMouseleaveRowEventOfTable($event)" (eventOnClick)="onEventOnClick($event)"
                [tableInput]='table'>
              </div>
            </div>
            @if (!isoldTableView) {
              <div class="ui-paging" [pagingInput]="paging"
                (eventOnClickPrevLink)="eventOnClickPrevLink($event)"
                (eventOnClickNextLink)="eventOnClickNextLink($event)">
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-container>
</section>